import React from 'react'
import { any, async, fromJSX, nothing, Updater, Widget } from 'widgets-for-react'
import { VerpleegafdelingenOverviewState } from './verpleegafdelingenOverviewState'
import { VerpleegafdelingenLayout } from './verpleegafdelingenOverviewLayout'

export const verpleegafdelingenOverviewWidget = (
  state: VerpleegafdelingenOverviewState
): Widget<Updater<VerpleegafdelingenOverviewState>> =>
  any<Updater<VerpleegafdelingenOverviewState>>([
    async(state.facilityItemsState).map((u) => (s) => ({ location: s.location, facilityItemsState: u(s.facilityItemsState) })),
    state.facilityItemsState.kind == 'loaded'
      ? fromJSX(() => (
          <>
            <VerpleegafdelingenLayout
              location={state.location}
              list={
                state.facilityItemsState.kind == 'loaded'
                  ? state.facilityItemsState.value.map((item) => ({
                      clinic: {
                        phoneNumber: item.clinic.phoneNumber,
                        visitingTimes: item.clinic.visitingTimes,
                        route: item.clinic.route,
                      },
                      facility: item.facility,
                    }))
                  : []
              }
              breadcrumbs={[
                { title: 'Spaarne Gasthuis', url: '/' },
                { url: '/verpleegafdelingen', title: 'Verpleegafdelingen' },
              ]}
            />
          </>
        ))
      : nothing(),
  ])
